import { router } from '@inertiajs/vue3';
import { ref } from 'vue';

export default function useBulkSelect(props) {
  const selectedModels = ref({});
  const selectedAll = ref(false);

  const toggleAll = (checked) => {
    selectedAll.value = checked;

    for (let key in props.resource.data) {
      let model = props.resource.data[key];
      selectedModels.value[model.data.id] = checked;
    }
  };

  const toggleSelected = (id, checked, event) => {
    if (
      !hasBulkEdit() ||
      event.target.parentElement.classList.contains('model-actions') ||
      event.target.parentElement.parentElement.classList.contains('model-actions')
    ) {
      return;
    }

    if (!event.target.href && !selectedAll.value) {
      selectedModels.value[id] = checked;
    }
  };

  const bulkSelected = () => {
    if (selectedAll.value) {
      return true;
    }

    return Object.values(selectedModels.value).includes(true);
  };

  const bulkDelete = (url, trans) => {
    if (!confirm(trans('common.BULK_DELETE_CONFIRM'))) {
      return;
    }

    router.post(url, { ids: selectedModels.value });
  };

  const bulkEdit = (url) => {
    router.post(url, { ids: selectedModels.value });
  };

  const hasBulkEdit = () => {
    if (props.mode !== 'full') {
      return false;
    }

    if (props.resource.meta.config.general?.bulkEdit) {
      return true;
    }

    return false;
  };

  return {
    selectedModels,
    selectedAll,
    toggleAll,
    toggleSelected,
    bulkSelected,
    bulkDelete,
    bulkEdit,
    hasBulkEdit,
  };
}
